import { groupThousandsInText } from 'shared/utils/thousandsSeparatorPositions';

/**
 * Draw thousands separators in a KaTeX-rendered formula (bug 535512): every whole number of four
 * or more digits reads grouped (80,000), matching what the MathLive editors paint (see shared
 * MathLiveField/groupDigits). Display-only — only text inside the VISIBLE `.katex-html` tree is
 * rewritten; the MathML accessibility twin (what screen readers speak) and its `<annotation>`
 * (the raw LaTeX for copy-paste) keep the plain number, as do all attributes (sizes, ids).
 */
export function groupThousandsInKatexHtml(html: string): string {
  // KaTeX output is only ever shown in the browser; anywhere without a DOM, pass it through.
  if (typeof DOMParser === 'undefined') return html;

  const body = new DOMParser().parseFromString(html, 'text/html').body;
  for (const visual of Array.from(body.querySelectorAll('.katex-html'))) {
    const walker = body.ownerDocument.createTreeWalker(visual, NodeFilter.SHOW_TEXT);
    for (let node = walker.nextNode(); node; node = walker.nextNode()) {
      const grouped = groupThousandsInText(node.textContent ?? '');
      if (grouped !== node.textContent) node.textContent = grouped;
    }
  }
  return body.innerHTML;
}
